var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"privacy"}},[_c('div',{staticClass:"bgdiv",domProps:{"innerHTML":_vm._s(_vm.info)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }